/**
 * Paginação padrão do app (estilo mercado): primeira « · anterior ‹ · números
 * com reticências · próxima › · última ». Use em TODA tabela paginada - 10
 * registros por página é o default do projeto (PAGE_SIZE).
 */
export const PAGE_SIZE = 10;

/** Janela de páginas a exibir, com -1 marcando reticência. */
function pageWindow(page: number, pageCount: number): number[] {
  // poucas páginas: mostra todas
  if (pageCount <= 7) return Array.from({ length: pageCount }, (_, i) => i + 1);
  const pages: number[] = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(pageCount - 1, page + 1);
  if (start > 2) pages.push(-1);
  for (let p = start; p <= end; p++) pages.push(p);
  if (end < pageCount - 1) pages.push(-1);
  pages.push(pageCount);
  return pages;
}

export function Pagination({
  page,
  pageCount,
  onChange,
  label,
}: {
  page: number;
  pageCount: number;
  onChange: (page: number) => void;
  /** Texto opcional à esquerda (ex.: "128 registro(s)"). */
  label?: string;
}) {
  if (pageCount <= 1) return null;
  const go = (p: number) => onChange(Math.min(pageCount, Math.max(1, p)));
  const win = pageWindow(page, pageCount);

  return (
    <nav className="pagination" aria-label="Paginação">
      {label && <span className="pagination-label">{label}</span>}
      <div className="pagination-controls">
        <button type="button" className="btn-page" disabled={page <= 1} onClick={() => go(1)} aria-label="Primeira página" title="Primeira">
          «
        </button>
        <button type="button" className="btn-page" disabled={page <= 1} onClick={() => go(page - 1)} aria-label="Página anterior" title="Anterior">
          ‹
        </button>
        {win.map((p, i) =>
          p === -1 ? (
            <span key={`gap-${i}`} className="pagination-gap" aria-hidden>
              …
            </span>
          ) : (
            <button
              key={p}
              type="button"
              className={`btn-page ${p === page ? "active" : ""}`}
              aria-current={p === page ? "page" : undefined}
              onClick={() => go(p)}
            >
              {p}
            </button>
          ),
        )}
        <button type="button" className="btn-page" disabled={page >= pageCount} onClick={() => go(page + 1)} aria-label="Próxima página" title="Próxima">
          ›
        </button>
        <button type="button" className="btn-page" disabled={page >= pageCount} onClick={() => go(pageCount)} aria-label="Última página" title="Última">
          »
        </button>
      </div>
    </nav>
  );
}
